<template>
    <div class="square">

        <div :class=" options == 'smaller' ? 'images-squared-smaller' : 'images-squared'">
            <div class="container-square-img">
                <div class="square-img" id="square-img"
                    :style="backgroundImg(1)"
                    @mouseover="hovered(1)"
                    @mouseleave="hovered(null)"
                    @click="imgClicked = 1">
                </div>
            </div>
            <span :class=" options == 'smaller' ? 'container-square-sm-img-smaller' : 'container-square-sm-img'">
                <div class="sm-container" v-for="imgNumber in [2,3,4]" :key="imgNumber">
                    <span class="img-count"
                        v-if="imgNumber == 4 && details.imgFolder.count > 4"
                        @mouseover="hovered(imgNumber)"
                        @mouseleave="hovered(null)"
                    >
                        <i class="fas fa-plus" style="font-size: 20px"/>{{ details.imgFolder.count }}
                    </span>
                    <div class="square-img-sm" id="square-img"
                        :style="backgroundImg(imgNumber)"
                        @mouseover="hovered(imgNumber)"
                        @mouseleave="hovered(null)"
                        @click="imgClicked = imgNumber"
                    >
                    </div>
                </div>
            </span>
        </div>
        <div class="image-details">
            <div class="text-left" style="display: flex">
                <span>
                    <i :class="'fas fa-' + this.details.place.icon"></i>
                </span>
                <span class="place-name">
                    {{ details.place.name }}
                </span>
            </div>
            <span class="text-right" v-if="details.date"> <i class="fas fa-calendar"></i> {{ details.date }} - {{ details.hour }} </span>
            <span class="text-right">
                <a class="location-link" :href="details.link.link" target="_blank" >
                    <i :class="!details.link.icon ? 'fas fa-map-marker-alt' : 'fas fa-' + details.link.icon"></i> {{ details.link.name }}
                </a>
            </span>
        </div>

        <LargeImage v-if="imgClicked" :img-clicked="imgClicked" :details="details.imgFolder" @hideImg="imgClicked = null"/>
    </div>
</template>

<script>
import LargeImage from './LargeImage.vue';
export default {

    components: {
        LargeImage
    },
  
    props: {
        colors:     { type: Object, required: true },
        details:    { type: Object, required: true },
        options:    { type: String, required: false },
    },

    data() {
        return {
            ishovered: null,
            imgClicked: null,
        }
    },

    methods: {
        backgroundImg(number){
            let colors = null;
            if (number == 0) {
                colors = 'rgba(' + this.colors.main + ',0), rgba(' + this.colors.main + ',.6)';
            } 
            else {
                let firstAlpha = number * .1 +.3;
                let secondAlpha = number * .1 +.4;
                colors = 'rgba(' + this.colors.main + ',' + firstAlpha + '), rgba(' + this.colors.main + ',' + secondAlpha + ')'
            }
            if(this.ishovered == number){
                return 'background: linear-gradient(' + colors + '), url(./img/' + this.details.imgFolder.name + '/' + number + '.jpg) no-repeat center center;' +
                'background-size: cover; transition: all .3s; transform: scale(1.05);';
            }
            else {
                return 'background: linear-gradient(' + colors + '), url(./img/' + this.details.imgFolder.name + '/' + number + '.jpg) no-repeat center center;' +
                'background-size: cover; transition: all .2s;';
            }
        },
        hovered(number){
            this.ishovered = number;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";

.container-square-img {
    width: 100%;
    height: 403px;
    overflow: hidden;
    margin: 1px 2px 0 0;
    .square-img {
        width: inherit;
        height: inherit;
    }
    @media screen and (max-width: $break-sm) {
        height: 250px;
    }
    @media screen and (max-height: 500px) and (max-width: $break-md){
        height: 280px;
    }
    @media screen and (max-height: 300px) and (max-width: $break-md){
        height: 230px;
    }
}

.container-square-sm-img {
    display:flex;
    flex-direction: column;
    flex-flow: column nowrap;
    @media screen and (max-width: $break-md) {
        flex-direction: row
    }
}

.container-square-sm-img-smaller {
    display:flex;
    flex-direction: row;
    @media screen and (max-width: $break-lg) {
        flex-direction: column;
    }
    @media screen and (max-width: $break-md) {
        flex-direction: row;
    }
}

.img-count {
    float: left;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 40px;
    opacity: .7;
    &:hover {
        opacity: 1;
    }
    @media screen and (max-width: $break-sm) {
        font-size: 30px;
    }
}

.image-details {
    display: flex;
    padding: 10px;
    font-size: 20px;
    color: #404040;
    margin: 0 10px 5px;
    align-items: flex-end;
    font-family: 'Dancing Script', Arial, sans-serif;
    .text-left {
        flex: 3;
        font-size: 27px;
        text-align: left;
        @media screen and (max-width: $break-lg) {
            margin: 2px 0;
        }
    }
    .text-right {
        flex: 2;
        text-align: right;
        @media screen and (max-width: $break-lg) {
            margin: 2px 0;
        }
    }
    @media screen and (max-width: $break-lg) {
        flex-direction: column
    }
}

.images-squared {
    display:flex;
    justify-content: center;
    @media screen and (max-width: $break-md) {
        flex-direction: column
    }

}

.images-squared-smaller {
    display:flex;
    justify-content: center;
    flex-direction: column;
    @media screen and (max-width: $break-lg) {
        flex-direction: row
    }
    @media screen and (max-width: $break-md) {
        flex-direction: column
    }

}

.location-link {
        text-decoration: none;
}

.place-name {
    flex: 1;
    margin-left: 10px
}

.sm-container {
    width: 220px;
    height: 133px;
    overflow: hidden;
    margin: 1px;
    .square-img-sm {
        width: inherit;
        height: inherit;
    }
    @media screen and (max-width: $break-sm) {
        height: 80px;
    }
}

.square {
    width: 70%;
    margin: 0 30px 20px 30px;
    background-color: white;
    box-shadow: 0px 0px 21px -13px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 21px -13px rgba(0,0,0,0.75);
    -webkit-box-shadow: 0px 0px 21px -13px rgba(0,0,0,0.65);
    @media screen and (max-width: $break-lg) {
        width: 70%;
    }
    @media screen and (max-width: $break-md) {
        width: 90%;
    }
    @media screen and (max-width: $break-sm) {
        width: 95%;
        margin: 0 0 20px 0;
    }
}

</style>
